export const isPaidUser = (user) => {
  return user?.role === "pre" && user?.isGiveAway === undefined;
};

export const isUsageUser = (user) => {
  return user?.isUsages === true;
};
